import { fileUrl } from "@/lib/quotationApi";

function RowKV({ k, v, mono }) {
  return (
    <div className="flex gap-3">
      <span className="text-white/40 w-14 shrink-0">{k}</span>
      <span
        className={`text-white/85 break-all ${mono ? "font-mono tracking-wider" : ""}`}
      >
        {v}
      </span>
    </div>
  );
}

export default function PublicPaymentInfo({ branding, primary }) {
  if (
    !branding.show_payment_info ||
    !(branding.bank_account_number || branding.upi_id || branding.qr_storage_path)
  ) {
    return null;
  }
  return (
    <div
      className="card-luxe mb-4"
      data-testid="public-payment-info"
      style={{ borderColor: `${primary}33` }}
    >
      <div
        className="overline mb-3"
        style={{ color: primary }}
      >
        Payment details
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-4 items-start">
        <div className="space-y-2.5 text-sm">
          {(branding.bank_account_name ||
            branding.bank_account_number ||
            branding.bank_name ||
            branding.ifsc_code) && (
            <div data-testid="public-payment-bank">
              <div className="overline text-[10px] text-white/40 mb-1.5">
                Bank transfer
              </div>
              <div className="space-y-1 text-[13px]">
                {branding.bank_account_name && (
                  <RowKV k="Name" v={branding.bank_account_name} />
                )}
                {branding.bank_name && (
                  <RowKV k="Bank" v={branding.bank_name} />
                )}
                {branding.bank_account_number && (
                  <RowKV
                    k="A/c"
                    v={branding.bank_account_number}
                    mono
                  />
                )}
                {branding.ifsc_code && (
                  <RowKV k="IFSC" v={branding.ifsc_code} mono />
                )}
              </div>
            </div>
          )}
          {branding.upi_id && (
            <div data-testid="public-payment-upi">
              <div className="overline text-[10px] text-white/40 mb-1.5">
                UPI
              </div>
              <div
                className="text-[13px] font-mono break-all"
                style={{ color: primary }}
              >
                {branding.upi_id}
              </div>
            </div>
          )}
        </div>
        {branding.qr_storage_path && (
          <div
            className="justify-self-center sm:justify-self-end"
            data-testid="public-payment-qr"
          >
            <img
              src={fileUrl(branding.qr_storage_path)}
              alt="Payment QR"
              className="w-32 h-32 rounded-lg object-contain bg-white p-2 border"
              style={{ borderColor: `${primary}55` }}
            />
            <div className="text-[10px] text-white/40 text-center mt-1.5">
              Scan to pay
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
